<div class="cg-main-page-container" *ngrxLet="routeData$ as routeData">
  <header role="banner">
    <cigna-evernorth-header
      [logoLink]="logoLink$ | async"
      [isLogoLinkInternal]="(isResourcePage$ | async) === false"
      [isAuthenticated]="false"
      [isNavigationDisabled]="
        routeData.disableNavigation || (siteDownFlag$ | async)
      "
    ></cigna-evernorth-header>
  </header>

  <main role="main">
    <ng-container *ngIf="siteDownFlag$ | async; else mainPage">
      <cigna-evernorth-unavailable
        [shouldShowRefreshBtn]="false"
      ></cigna-evernorth-unavailable>
    </ng-container>
    <ng-template #mainPage> <router-outlet></router-outlet></ng-template>
  </main>

  <footer role="contentinfo" class="cg-hide-for-print">
    <cigna-evernorth-footer></cigna-evernorth-footer>
  </footer>
</div>
